module.exports = __webpack_public_path__ + "img/prepaid-cards.010c495.svg";